import {StackScreenProps} from '@react-navigation/stack';
import {Toast} from 'native-base';
import React, {useEffect} from 'react';
import {WebView, WebViewMessageEvent} from 'react-native-webview';
import {showError} from '../lib/errorHandler';
import {triggerHapticFeedback} from '../lib/hapticFeedback';
import i18n from '../lib/i18n';
import {parseJSON} from '../lib/utils';
import {Nav, NavParams} from './navigation';

type PaymentResponse = {
  type: 'payment_response';
  payload: {
    id: string;
    orderId: string;
    status: string;
    statusMessage: string;
  };
};

export const RechargeViewScreen: React.FC<StackScreenProps<NavParams, Nav.RechargeViewScreen>> = ({
  route,
  navigation
}) => {
  const handleMessage = (event: WebViewMessageEvent) => {
    const data = parseJSON<PaymentResponse>(event.nativeEvent.data);
    if (data?.type === 'payment_response') {
      if (data.payload.status === 'SUCCEEDED') {
        triggerHapticFeedback();
        Toast.show({
          description: i18n.t('rechargeSuccess'),
          duration: 3000
        });
        navigation.navigate(Nav.HomeScreen);
      }
      if (data.payload.status === 'FAILED') {
        triggerHapticFeedback();
        showError(data.payload.statusMessage);
        navigation.navigate(Nav.RechargeScreen);
      }
    }
  };

  return (
    <WebView
      style={{flex: 1}}
      onMessage={handleMessage}
      source={{uri: `${route.params.url}?locale=${i18n.locale}`}}
    />
  );
};
